import { NOTIFICATION_TYPES } from "./types";

export function buildDefaultNotificationPrefs() {
  return {
    soundEnabled: true,
    soundOnlyBackground: true,
    desktopEnabled: false,
    categories: {
      [NOTIFICATION_TYPES.chat_message]: true,
      [NOTIFICATION_TYPES.new_request]: true,
      [NOTIFICATION_TYPES.request_assigned]: true,
      [NOTIFICATION_TYPES.system]: true,
      [NOTIFICATION_TYPES.billing]: true,
      [NOTIFICATION_TYPES.security]: true,
      [NOTIFICATION_TYPES.legacy_socket]: true,
    },
  };
}

export function normalizePrefsPartial(p) {
  const d = buildDefaultNotificationPrefs();
  if (!p || typeof p !== "object") return d;
  return {
    ...d,
    ...p,
    categories: { ...d.categories, ...(p.categories || {}) },
  };
}

/** @param {unknown} raw coluna JSON / string / objeto da API */
export function parseNotificationPrefsFromApi(raw) {
  if (raw == null || raw === "") return null;
  if (typeof raw === "object" && !Array.isArray(raw)) {
    return normalizePrefsPartial(raw);
  }
  if (typeof raw === "string") {
    try {
      return normalizePrefsPartial(JSON.parse(raw));
    } catch {
      return null;
    }
  }
  return null;
}
